module.exports = __WEBPACK_EXTERNAL_MODULE_209__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/BehaviorSubject"
// module id = 209
// module chunks = 0